export default {
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW",
  "APP_FULFILLMENT_VIEW": "APP_FULFILLMENT_VIEW",
  "APP_LEGACY_FULFILLMENT_VIEW": "APP_LEGACY_FULFILLMENT_VIEW",
  "APP_JOB_MANAGER_VIEW": "APP_JOB_MANAGER_VIEW",
  "APP_ACCXUI_JOB_MANAGER_VIEW": "APP_ACCXUI_JOB_MANAGER_VIEW",
  "APP_COMPANY_VIEW": "APP_COMPANY_VIEW",
  "APP_RECEIVING_VIEW": "APP_RECEIVING_VIEW",
  "APP_LEGACY_RECEIVING_VIEW": "APP_LEGACY_RECEIVING_VIEW",
  "APP_PRODUCTS_VIEW": "APP_PRODUCTS_VIEW",
  "APP_ORDER_MANAGER_VIEW": "APP_ORDER_MANAGER_VIEW",
  "APP_ORDER_ROUTING_VIEW": "APP_ORDER_ROUTING_VIEW",
  "APP_USERS_VIEW": "APP_USERS_VIEW",
  "APP_FACILITIES_VIEW": "APP_FACILITIES_VIEW",
  "APP_TRANSFERS_VIEW": "APP_TRANSFERS_VIEW",
  "APP_IMPORT_VIEW": "APP_IMPORT_VIEW",
  "APP_INVENTORY_COUNT_VIEW": "APP_INVENTORY_COUNT_VIEW",
  "APP_BOPIS_VIEW": "APP_BOPIS_VIEW",
  "APP_PREORDER_VIEW": "APP_PREORDER_VIEW",
  "APP_ATP_VIEW": "APP_ATP_VIEW"
} 